<script setup lang="ts">
import { useRouterPush } from '@/hooks/common/router';

const { routerPushByKey } = useRouterPush();

function toScanPage() {
  routerPushByKey('qrcode-scan');
}
</script>

<template>
  <ButtonIcon tooltip-content="扫描二维码" icon="mingcute:barcode-scan-line" @click="toScanPage" />
</template>

<style scoped></style>
